var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8327 11.0833V2.91667C12.8327 2.27232 12.3104 1.75 11.666 1.75H2.33268C1.68833 1.75 1.16602 2.27232 1.16602 2.91667V11.0833C1.16602 11.7277 1.68833 12.25 2.33268 12.25H11.666C12.3104 12.25 12.8327 11.7277 12.8327 11.0833ZM6.99935 8.55686C6.68773 8.55686 6.3767 8.47309 6.09927 8.30678L2.33268 6.04689V4.68638L6.69917 7.30642C6.88373 7.41697 7.11444 7.41697 7.30017 7.30642L11.6661 4.68638V6.04695L7.90002 8.30672C7.622 8.47309 7.31038 8.55686 6.99935 8.55686Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.0134b5727ec684c9af8c219382c331c8.svg";
export { ForwardRef as ReactComponent };